import React from 'react';
import { CodeEditor } from '../code_editor/CodeEditor';
import { parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';
import { isImmutable } from 'immutable';

export const CodeEditorField = props => {
  const renderOptions = parseRenderOptions(props);

  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <CodeEditor
        title={props.label}
        language={props.language}
        className={classNames(renderOptions.fieldClassName, {
          'cm-invalid': renderOptions.hasErrors,
        })}
        wrapperClassName={classNames({
          [`code-editor--min-${renderOptions.custom.min}`]:
            !!renderOptions.custom.min,
          [`code-editor--max-${renderOptions.custom.max}`]:
            !!renderOptions.custom.max,
        })}
        id={props.id}
        bindings={
          isImmutable(props.options) ? props.options.toJS() : props.options
        }
        value={props.value || ''}
        onBlur={props.onBlur}
        onChange={props.onChange}
        onFocus={props.onFocus}
        focusRef={props.focusRef}
        placeholder={renderOptions.placeholder}
        disabled={!props.enabled}
        allowCopy={renderOptions.custom.allowCopy}
        simple={renderOptions.custom.simple}
      />
    </FieldWrapper>
  );
};

export const CodeField = CodeEditorField;
